
import { Mixins, Component, Watch } from "vue-property-decorator";
import {
  getInvoices,
  updateInvoice,
  deleteInvoice,
} from "@pazion/pazion-catalog/src/services/catalog-service";
import { DataTableHeader } from "vuetify";
import { IInvoice } from "@pazion/pazion-catalog/src/models/invoice";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import { AxiosError } from "axios";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";
import { ITablePaginationOptions } from "@pazion/pazion-catalog/src/models/base";
import InvoiceDetailsModal from "@pazion/pazion-catalog/src/views/invoices/modals/InvoiceDetailsModal.vue";
import InvoiceAttributesMixin from "@pazion/pazion-catalog/src/views/invoices/mixins/invoiceAttributes.mixin";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import EntityLogDialog from "@pazion/pazion-core/src/components/utils/EntityLogDialog.vue";
import EntityLogMixin from "@pazion/pazion-core/src/mixins/EntityLog.mixin";
import PazListFilterSelector from "@pazion/pazion-core/src/components/utils/PazListFilterSelector.vue";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import {IFulfilment} from "@pazion/pazion-catalog/src/models/fulfilment";
import PazDocumentsDialog from "@pazion/pazion-catalog/src/components/dialog/PazDocumentsDialog.vue";

@Component({
  components: {
    PazDocumentsDialog,
    EntityLogDialog,
    PazTooltipButton,
    PazToast,
    InvoiceDetailsModal,
    PazRefreshButton,
    PazListFilterSelector,
  },
})
export default class InvoicesListing extends Mixins(
    InvoiceAttributesMixin, EntityLogMixin, PermissionService
) {
  $refs!: {
    toast: PazToast;
  };
  defaultEntityType = "invoice";
  public search: string = "";
  public loading: boolean = true;
  public footerProps = {
    itemsPerPageOptions: [50, 100, 200, -1],
  };
  public paginationOptions: ITablePaginationOptions = { itemsPerPage: 100 };
  public totalItems = 1;
  public selectedStatusesList: string[] = [];

  public statusesListOptions = [
    { title: "NEW", value: "NEW" },
    { title: "FAILED", value: "FAILED" },
    { title: "PROCESSED", value: "PROCESSED" },
  ];

  public defaultQueryPaginationsOpt = {
    pagination: 1,
    perPage: 50,
    page: 1,
    expand: "attributeValue,file",
  };

  public headers: DataTableHeader[] = [
    {
      text: "id",
      align: "start",
      sortable: true,
      value: "id",
    },
    {
      text: "Order",
      align: "start",
      sortable: true,
      value: "orderId",
    },
    {
      text: "invoice number",
      align: "center",
      sortable: true,
      value: "invoiceNumber",
    },
    {
      text: "reference",
      align: "center",
      sortable: true,
      value: "reference",
    },
    {
      text: "description",
      align: "center",
      sortable: true,
      value: "description",
    },
    {
      text: "customer",
      align: "center",
      sortable: true,
      value: "customer",
    },
    {
      text: "invoice date",
      align: "center",
      sortable: true,
      value: "invoiceDate",
    },
    {
      text: "payment status",
      align: "center",
      sortable: true,
      value: "payment_status",
    },
    {
      text: "tax",
      align: "center",
      sortable: true,
      value: "tax",
    },
    {
      text: "total",
      align: "center",
      sortable: true,
      value: "total",
    },
    {
      text: "status",
      align: "center",
      sortable: true,
      value: "status",
    },
    {
      text: "Actions",
      align: "end",
      sortable: false,
      value: "actions",
    },
  ];
  public items: IInvoice[] = [];
  public dialog: boolean = false;
  private _timerId = null;
  public showDetailsModal: boolean = false;
  public selectedInvoice: any = null;

  linkToOrder(orderId: number | string) {
    this.$router.push({
      name: "orders",
      query: {orderId: orderId},
    });
  }

  get canShowInvoiceFiles() {
    return this.hasProfileFlag("fulfilmentManagement.files");
  }


  public showFilesModal: boolean = false;
  public selectedItem?: IInvoice|null = null;

  toogleDetailsDialog(status, item: any) {
    this.selectedInvoice = item && item;
    this.showDetailsModal = status;
  }

  async toggleFilesDialog(item: IFulfilment) {
    this.selectedItem = item;
    this.showFilesModal = !this.showFilesModal;
  }

  async onRetryClick(id: number) {
    try {
      this.loading = true;
      let data = {
        id,
        status: "NEW",
      };
      const response = await this.updateInvoice(data);
      this.$refs.toast.show({ message: `Invoice #${response.id} retried` });
      await this.onSearch();
    } catch (error) {
      let response = (error as AxiosError).response;
      if (response && response.status !== 500) {
        this.$refs.toast.show({
          message: response.data.message,
          color: "red",
          icon: "mdi-close-circle",
        });
        this.loading = false;
        return;
      }
      this.loading = false;
      this.$refs.toast.show({
        message: "An error occurred, please contact the administrator",
        icon: "mdi-close-circle",
        color: "red",
      });
    } finally {
      this.showDetailsModal = false;
    }
  }

  isInvoiceStatusNotFailed(invoice: IInvoice): boolean {
    return invoice.status === "FAILED";
  }
  async updateInvoice(data: any) {
    return await updateInvoice(data);
  }
  formatDate(date: string): string {
    if (date == null) {
      return "";
    }
    return new Date(date).toLocaleDateString("nl-nl", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  get getTableHeaders() {
    let headers = this.headers;
    if (!this.$invoicePaymentManagement) {
      headers = headers.filter((h) => h && h.value !== "payment_status");
    }
    headers = !this.$contractManagement
      ? headers.filter(
          (h) => h && !["customer", "tax", "total"].includes(h.value)
        )
      : headers;
    return headers;
  }

  async onSearch() {
    clearTimeout(this._timerId);
    this._timerId = setTimeout(async () => {
      const searchString = this.createFiltersObject();
      const queryParams = searchString && {
        ...this.defaultQueryPaginationsOpt,
        filter: JSON.stringify({
          ...searchString,
        }),
      };

      await this.fetchData(queryParams, true);
    }, 800);
  }

  createSearchString(search: string, wildCards: boolean=true) {
    if(search.length == 0){
      return null;
    }
    if(wildCards){
      return { like: `%${this.search.trim()}%` };
    }
    return { eq: `${this.search.trim()}` };
  }

  createFiltersObject() {
    const filter: {
      status?: { in: string[] };
      operator?: any;
      id?: any;
      order?: any;
      description?: any;
      reference?: any;
    } = {};

    if (this.selectedStatusesList.length) {
      filter.status = { in: this.selectedStatusesList };
    }
    if (this.search.length > 0) {
      filter.operator = "OR";
      filter.id = this.createSearchString(this.search);
      filter.description = this.createSearchString(this.search);
      filter.order = this.createSearchString(this.search, false);
      filter.reference = this.createSearchString(this.search);
    }
    return filter;
  }

  async fetchData(
    queryParams?: { [key: string]: any | { [key: string]: string } } | {},
    isAllRecords?: boolean
  ) {
    const fullParams = queryParams
      ? queryParams
      : this.defaultQueryPaginationsOpt;
    try {
      this.loading = true;
      const response = await getInvoices({
        ...fullParams,
      });
      if (!response) return;
      this.items = response;
      this.totalItems = response._pagination._total;
      Object.assign(this.paginationOptions, {
        page: response._pagination._page,
        itemsPerPage: isAllRecords ? -1 : response._pagination._per_page,
      });
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
  // NOTE: FROM Paginastion
  @Watch("paginationOptions")
  onUpdatePaginations(val, oldVal) {
    if (
      val.itemsPerPage !== oldVal.itemsPerPage ||
      val.page !== oldVal.page ||
      val.sortBy.length > 0
    ) {
      let pagiantionParams;
      if (val.itemsPerPage > 0)
        pagiantionParams = {
          pagination: 1,
          perPage: val.itemsPerPage,
          page: val.page,
          expand: "attributeValue,file",
        };
      else {
        pagiantionParams = this.defaultQueryPaginationsOpt;
        pagiantionParams.perPage = 200;
      }
      let filters = this.createFiltersObject();
      filters &&
        Object.assign(pagiantionParams, { filter: JSON.stringify(filters) });
      this.fetchData(pagiantionParams, val.itemsPerPage === -1);
    }
  }

  async handleDeleteInvoice(id: number) {
    await deleteInvoice(id);
    await this.fetchData();
  }

  get getOffersArray() {
    return (this.items && this.items?._data) || [];
  }
} //
